import { Link } from "react-router-dom";
import { SectionHeading } from "@/components/SectionHeading";
import { STORE } from "@/constants/testIds";
import { REFUND_TEXT, CONTACT_EMAIL } from "@/data/content";

const Container = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </div>
);

export default function Refund() {
  return (
    <div data-testid={STORE.refundPage} className="bg-[var(--ibp-offwhite)]">
      <section className="bg-[var(--ibp-navy-950)] py-12 text-white sm:py-16">
        <Container>
          <SectionHeading tone="navy" kicker="Policy" title="Refund Policy" />
        </Container>
      </section>

      <section className="py-14 sm:py-20">
        <Container>
          <div className="mx-auto max-w-3xl rounded-2xl border border-[color:rgba(10,27,51,0.12)] bg-white p-7 shadow-[0_10px_30px_rgba(7,20,39,0.06)] sm:p-9">
            <p className="text-base leading-7 text-[var(--ibp-ink)]">
              {REFUND_TEXT}
            </p>

            <div className="mt-7 border-t border-[color:rgba(10,27,51,0.10)] pt-7">
              <h2 className="font-[var(--font-heading)] text-lg font-semibold text-[var(--ibp-ink)]">
                How to request a review
              </h2>
              <p className="mt-3 text-sm leading-6 text-[color:rgba(11,18,32,0.72)]">
                Email{" "}
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="font-semibold text-[#0F3D8A] hover:underline"
                >
                  {CONTACT_EMAIL}
                </a>{" "}
                within 7 days of purchase with your order details and a short
                description of the issue. You can also use our{" "}
                <Link to="/contact" className="font-semibold text-[#0F3D8A] hover:underline">
                  contact form
                </Link>
                .
              </p>
            </div>

            <p className="mt-7 text-xs leading-5 text-[color:rgba(11,18,32,0.55)]">
              Note: No refund is offered for failing an exam, not using the
              product, or expecting official PSI/IDFPR material. This product is
              an independent study aid.
            </p>
          </div>
        </Container>
      </section>
    </div>
  );
}
